<template>
    <div>
        <div class="form-group block">
            <label for="type">Mijn rol <small class="text-danger">*</small></label>
            <select v-model="type" class="form-control custom-select" name="type" id="type">
                <option value="employee">Werknemer</option>
                <option value="employer">Werkgever</option>
            </select>
        </div>

        <template v-if="type === 'employee'">
            <div class="custom-control custom-checkbox mb-2">
                <input v-model="terms_employee" type="checkbox" class="custom-control-input" name="terms_employee" id="terms_employee">
                <label class="text-small custom-control-label" for="terms_employee">Ik ga akkoord met de <a class="text-primary font-weight-bold" :href="terms_employee_route" target="_blank">algemene voorwaarden</a> voor werknemers. <small class="text-danger">*</small></label>
                <small v-if="this.errors && this.errors.terms_employee" class="text-danger d-block">{{this.errors.terms_employee[0]}}</small>
            </div>
        </template>

        <template v-else="">
            <div class="custom-control custom-checkbox mb-2">
                <input v-model="terms_employer" type="checkbox" class="custom-control-input" name="terms_employer" id="terms_employer">
                <label class="text-small custom-control-label" for="terms_employer">Ik ga akkoord met de <a class="text-primary font-weight-bold" :href="terms_employer_route" target="_blank">algemene voorwaarden</a> voor werkgevers. <small class="text-danger">*</small></label>
                <small v-if="this.errors && this.errors.terms_employer" class="text-danger d-block">{{this.errors.terms_employer[0]}}</small>
            </div>
        </template>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                type: 'employee',
                terms_employee: false,
                terms_employer: false
            }
        },
        props: {
            errors: {},
            old: {},
            terms_employee_route: String,
            terms_employer_route: String,
        },
        mounted() {
            if(Object.keys(this.old).length > 0)
            {
                this.type = this.old.type;
                this.terms_employee = !!this.old.terms_employee;
                this.terms_employer = !!this.old.terms_employer;
            }
        },
    }
</script>
